import React from 'react'
import PSAHero from './PSAHero'
import Page from 'src/views/staticHomeView/ContactView/Page'
import {
  Box,
  Container,
  Grid,
  makeStyles,
  Typography,
  useMediaQuery
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import PSAPort from '../../../assets/psaAssets/home-page.jpg'
import DataIntegration from '../../../assets/psaAssets/DataIntegration.svg'
import CostSaving from '../../../assets/psaAssets/CostSaving.svg'
import RealTimeNotification from '../../../assets/psaAssets/RealTimeNotification.svg'
import LowSetupCost from '../../../assets/psaAssets/LowSetupCost.svg'
import CompleteCompliance from '../../../assets/psaAssets/CompleteCompliance.svg'
import { components } from 'cng-web-lib'
import '../../../assets/scss/psaCustomCss.css';

const {
  button: { CngButton }
} = components

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: '"Asap", sans-serif',
  },
  register: {
    backgroundColor: '#f2f1ef',
    borderRadius: 16,
    padding: 48,
    [theme.breakpoints.down('md')]: {
      padding: 24,
    },
  },
  button: {
  backgroundColor: '#f3a73e',
  borderRadius: 999,
  boxShadow: 'none',
  color: '#ffffff',
  fontSize: 16,
  fontWeight: 700,
  textTransform: 'none',
  fontFamily: '"Asap", sans-serif',
  '&:hover': {
    backgroundColor: '#d98f1f',
    boxShadow: `0px 3px 7px rgba(0, 0, 0, 0.08),
                0px 6px 12px -2px rgba(0, 0, 0, 0.09),
                0px 15px 32px -3px rgba(0, 0, 0, 0.1)`
  },
  '&:focus': {
    backgroundColor: '#d98f1f'
  },

  '&:active': {
    backgroundColor: '#a66a12'
  }
},
  background1: {
    backgroundColor: '#F4F1EE',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'bottom',
    minHeight: 550,
  },
  background2: {
    backgroundColor: '#FFFFFF',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
  divider: {
    height: 4,
    width: 48,
    maxWidth: '100%',
    backgroundColor: '#f3a73e',
  },
  PSAPort: {
    width: '100%',
    borderRadius: 16,
  },
  heading: {
    fontFamily: '"Asap", sans-serif',
    fontWeight: 700,
  },
  subHeading: {
    fontFamily: '"Asap", sans-serif',
    fontWeight: 500,
  },
  benefitTitle: {
    fontFamily: '"Asap", sans-serif',
    fontWeight: 700,
  },
  benefitDescription: {
    fontFamily: '"Asap", sans-serif',
  },
}))

function PSAHomeView() {
  const classes = useStyles()
  const history = useHistory()
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down('md'))

  sessionStorage.clear()
  sessionStorage.setItem('homePagePath', '/psa')

  return (
    <Page title='Home' className={classes.root}>
      <Box className={classes.background1}>
        <PSAHero />
      </Box>

      <Box pb={6}>
        <Container>
          <Grid alignItems='center' container>
            <Grid item xs={12} lg={6}>
              <Box paddingRight={mdDown ? 0 : 10} paddingBottom={mdDown ? 6 : 0}>
                <img src={PSAPort} className={classes.PSAPort} alt='PSA Port' />
              </Box>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Typography variant='h1' className={classes.heading}>
                Smarter Data. Faster Workflows.
              </Typography>

              <Box my={2}>
                <Box className={classes.divider} />
              </Box>

              <Typography className={classes.benefitDescription} style={{ marginBottom: 8 }}>
                The PSAH's Digital Trade Navigator connects directly with the <strong>U.S. Customs and 
                Border Protection (CBP)</strong> and the <strong>Canada Border Services Agency (CBSA) </strong>
                to manage all critical compliance requirements, fast, accurate, and secure.
              </Typography>

              <Typography className={classes.benefitDescription} style={{ marginBottom: 8 }}>
                Built on the principle of "enter once, use everywhere," and powered by robust 
                integration capabilities, the Trade Navigator dramatically improves data accuracy, 
                streamlines workflows, and reduces operational costs, giving businesses a smarter, 
                faster way to manage compliance and documentation.
              </Typography>

              <Typography className={classes.benefitDescription} style={{ marginBottom: 8 }}>
                <strong>Highway ACI/ACE:</strong> Accelerate cross-border trucking with instant 
                eManifest creation and submission for both U.S. (ACE) and Canadian (ACI) requirements, 
                ensuring fast, compliant highway shipments without delays.
              </Typography>

              <Typography className={classes.benefitDescription} style={{ marginBottom: 8 }}>
                <strong>Ocean ACI/ACE:</strong> Simplify ocean freight compliance with powerful tools 
                to manage eManifest submissions. Pre-clear vessel arrivals and cargo movements for CBP 
                and CBSA, reducing bottlenecks and keeping your supply chain moving.
              </Typography>

              <Typography className={classes.benefitDescription} style={{ marginBottom: 8 }}>
                <strong>Electronic House Bill of Lading (eHBL):</strong> Automates creation and 
                transmission of accurate eHBL, reducing manual errors and accelerating the 
                clearance process for freight forwarders.
              </Typography>

              <Typography className={classes.benefitDescription} style={{ marginBottom: 8 }}>
                <strong>FDA Prior Notice (FDA PN):</strong> Enables seamless submission of Prior 
                Notices for regulated shipments, ensuring compliance before cargo arrives at U.S. ports.
              </Typography>

              <Typography className={classes.benefitDescription} style={{ marginBottom: 8 }}>
                <strong>Release Notification System (RNS WACM):</strong> Streamlines warehouse operations 
                by automatically transmitting electronic notifications to CBSA when goods arrive at a 
                sufferance warehouse, signaling readiness for processing and potential release, with the 
                capability to receive critical CBSA notices to avoid delays and accelerate clearance.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box className={classes.background2}>
        <Container>
          <Box py={6}>
            <Typography variant='h1' className={classes.heading} style={{ textAlign: 'center' }}>
              PSAH Digital Trade Navigator Benefits
            </Typography>
            <Box mt={2} mb={5}>
              <Box className={classes.divider} style={{ margin: '0 auto' }} />
            </Box>

            <Grid container spacing={2} wrap='nowrap' style={{ width: '100%', overflowX: 'auto' }}>
              <Grid item xs='auto' style={{ flexGrow: 1 }}>
                <Benefit
                  icon={CompleteCompliance}
                  title='Complete Compliance'
                  description={
                    <>Stay compliant with all mandatory Customs filings, ACI, ACE, eHBL, RNS WACM, and FDA PN, through one intuitive platform. Ensure accuracy and timely submissions to avoid costly delays and penalties at the border.</>
                  }
                  classes={classes}
                />
              </Grid>

              <Grid item xs='auto' style={{ flexGrow: 1 }}>
                <Benefit
                  icon={DataIntegration}
                  title='Data Integration'
                  description='Reuse common data fields across eManifests, invoices, and HBLs. Speed up repetitive filings with templates and cloning, while seamless integration with your dispatch or inventory systems keeps workflows connected and error-free.'
                  classes={classes}
                />
              </Grid>

              <Grid item xs='auto' style={{ flexGrow: 1 }}>
                <Benefit
                  icon={RealTimeNotification}
                  title='Real-Time Notification'
                  description={
                    'Get instant visibility with real-time notifications on Customs responses and shipment statuses, delivered within seconds. Stay informed and confident before your cargo reaches the border.'
                  }
                  classes={classes}
                />
              </Grid>

              <Grid item xs='auto' style={{ flexGrow: 1 }}>
                <Benefit
                  icon={CostSaving}
                  title='Cost Savings'
                  description={
                    'Automated compliance workflows reduce manual data entry and minimizes costly mistakes. This means faster processing, fewer delays, and lower operational expenses, giving your business more efficiency and profitability.'
                  }
                  classes={classes}
                />
              </Grid>

              <Grid item xs='auto' style={{ flexGrow: 1 }}>
                <Benefit
                  icon={LowSetupCost}
                  title='Low Start-Up Costs'
                  description={<>Start instantly with zero IT hassle. As a fully web-based solution, there's no software to install, no maintenance, and no heavy overhead, just log in from any PC with an internet connection and you're ready to go.</>}
                  classes={classes}
                />
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </Page>
  )
}

function Benefit({ icon, title, description, classes }) {
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <img 
          src={icon} 
          alt={title} 
          style={{ width: 50, height: 50, objectFit: 'contain' }} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h4' className={classes.benefitTitle}>
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.benefitDescription}>{description}</Typography>
      </Grid>
    </Grid>
  )
}


export default PSAHomeView
